import styled, { css } from 'styled-components';

export const WizardCardList = styled.div<{ $fullHeight?: boolean; $maxWidth?: string }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: var(--sizes-50);
  ${({ $maxWidth }) =>
    $maxWidth &&
    css`
      max-width: ${$maxWidth};
    `}
  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      height: 100%;
    `}
  width: 100%;
`;

export const WizardCardContainer = styled.div<{
  $addChildrenDivider?: boolean;
  $childrenBelowHeader?: boolean;
  $padding?: number;
}>`
  border-radius: var(--sizes-30);
  border: 1px solid var(--color-gray-20);
  background: var(--color-grayscale-white);
  overflow-x: auto;
  padding: ${({ $padding }) => (typeof $padding === 'number' ? `${$padding}px` : 'var(--sizes-70)')};

  ${({ $addChildrenDivider }) =>
    $addChildrenDivider
      ? css`
          width: 100%;
        `
      : css`
          align-items: flex-start;
          align-self: stretch;
          display: flex;
          gap: 80px;
          justify-content: space-between;
        `}

  ${({ $childrenBelowHeader }) =>
    $childrenBelowHeader &&
    css`
      flex-direction: column;
      gap: 16px;
    `}
`;

export const WizardCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const WizardCardHeaderActions = styled.div`
  display: flex;
  gap: var(--sizes-20);
`;

export const VerticalWizardCardContainer = styled.div<{ $padding?: number }>`
  border-radius: var(--sizes-30);
  border: 1px solid var(--color-gray-20);
  background: var(--color-grayscale-white);
  overflow-x: auto;
  padding: ${({ $padding }) => (typeof $padding === 'number' ? `${$padding}px` : 'var(--sizes-70)')};

  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: var(--sizes-30);
  justify-content: space-between;
`;

export const WizardCardInfo = styled.div<{ $addChildrenDivider?: boolean; $infoGap?: string; $infoWidth?: string }>`
  display: flex;
  flex: 0 0 225px;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ $infoGap }) => $infoGap ?? `var(--sizes-20)`};

  ${({ $addChildrenDivider }) =>
    $addChildrenDivider &&
    css`
      padding: var(--sizes-60);
    `}

  ${({ $infoWidth }) =>
    $infoWidth &&
    css`
      flex: unset;
      width: ${$infoWidth};
    `}
`;

export const WizardCardTitle = styled.h4<{ $titleSize?: number }>`
  color: var(--color-grayscale-black);
  font: var(--font-regular-14pt-semibold);
  font-size: ${({ $titleSize }) => $titleSize ?? 14}px;
  margin: 0;
`;

export const WizardCardDescription = styled.p<{ $descriptionSize?: number }>`
  color: var(--color-gray-90);
  font: var(--font-extra-small-12pt-normal);
  font-size: ${({ $descriptionSize }) => $descriptionSize ?? 12}px;
  letter-spacing: 0.06px;
`;

export const WizardCardChildrenWrapper = styled.div<{ $width?: string }>`
  flex: 1 0 0;
  ${({ $width }) =>
    $width &&
    css`
      width: ${$width};
    `}
`;

export const FullWidthCardContainer = styled(WizardCardContainer)<{ $compact?: boolean; $unpadded?: boolean }>`
  flex-direction: column;
  gap: ${({ $compact }) => ($compact ? 'var(--sizes-40)' : 'var(--sizes-70)')};
  ${({ $unpadded }) =>
    $unpadded &&
    css`
      padding: 0;
      flex-grow: 1;
      height: 100%;
    `}
`;

export const FullWidthCardInfo = styled(WizardCardInfo)<{ $alignLeft?: boolean }>`
  flex: 1 0 auto;
  width: 100%;
  align-items: ${({ $alignLeft }) => ($alignLeft ? 'flex-start' : 'center')};
`;

export const FullWidthCardTitle = styled.h3<{ $compact?: boolean }>`
  font: ${({ $compact }) => ($compact ? 'var(--font-regular-14pt-semibold)' : 'var(--font-headings-heading-3)')};
  color: var(--color-grayscale-black);
  margin: 0;
`;

export const FullWidthCardDescription = styled.div<{ $compact?: boolean }>`
  ${({ $compact }) =>
    $compact &&
    css`
      font: var(--font-small-13pt-normal);
      color: var(--color-gray-80);
    `}
  ${({ $compact }) =>
    !$compact &&
    css`
      font: var(--font-regular-14pt-normal);
      color: var(--color-gray-90);
    `}
  line-height: 20px;
`;

export const FullWidthCardContentWrapper = styled.div`
  width: 100%;
`;
